'use client';

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselContent, CarouselItem } from '@svenskaspelab/ui/react/carousel';
import { Children, useCallback, useEffect, useState } from 'react';
import CarouselNavigationIndicator from './CarouselNavigationIndicator.js';
export default function ContentCarousel(t0) {
  const $ = _c(22);
  const {
    children,
    slideIds,
    slides,
    title,
    subTitle,
    loop,
    slidesToScroll: t1
  } = t0;
  const slidesToScroll = t1 === undefined ? "auto" : t1;
  const [api, setApi] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [scrollSnaps, setScrollSnaps] = useState(t2);
  let t3;
  if ($[1] !== api) {
    t3 = () => {
      if (!api) {
        return;
      }
      setSelectedIndex(api.selectedScrollSnap());
    };
    $[1] = api;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const onSelect = t3;
  let t4;
  if ($[3] !== api) {
    t4 = () => {
      if (!api) {
        return;
      }
      setScrollSnaps(api.scrollSnapList());
      setSelectedIndex(api.selectedScrollSnap());
    };
    $[3] = api;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onReInit = t4;
  let t5;
  let t6;
  if ($[5] !== api || $[6] !== onReInit || $[7] !== onSelect) {
    t5 = () => {
      if (api) {
        setScrollSnaps(api.scrollSnapList());
        onSelect();
        onReInit();
        api.on("select", onSelect);
        api.on("reInit", onReInit);
      }
      return () => {
        api?.off("select", onSelect);
        api?.off("reInit", onReInit);
      };
    };
    t6 = [api, onReInit, onSelect];
    $[5] = api;
    $[6] = onReInit;
    $[7] = onSelect;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  const hasMultiplePages = scrollSnaps.length > 1;
  let t7;
  if ($[10] !== api || $[11] !== children || $[12] !== hasMultiplePages || $[13] !== loop || $[14] !== scrollSnaps.length || $[15] !== selectedIndex || $[16] !== slideIds || $[17] !== slides || $[18] !== slidesToScroll || $[19] !== subTitle || $[20] !== title) {
    const carouselSlides = children !== undefined ? Children.toArray(children).map((node, index) => ({
      id: slideIds?.[index] ?? `slide-${index}`,
      node
    })) : slides ?? [];
    const shouldLoop = loop ?? false;
    t7 = _jsxs("div", {
      className: "@container",
      children: [_jsxs("div", {
        className: "mb-2 flex items-center",
        children: [title || subTitle ? _jsxs("div", {
          children: [title ? _jsx("h2", {
            className: "text-lg font-semibold",
            children: title
          }) : null, subTitle ? _jsx("p", {
            className: "text-muted-foreground text-sm",
            children: subTitle
          }) : null]
        }) : null, hasMultiplePages ? _jsx("div", {
          className: "ml-auto hidden md:block",
          children: _jsx(CarouselNavigationIndicator, {
            count: scrollSnaps.length,
            selectedIndex,
            onDotClick: index_0 => api?.scrollTo(index_0),
            onPrevious: () => api?.scrollPrev(),
            onNext: () => api?.scrollNext(),
            canScrollPrev: selectedIndex > 0,
            canScrollNext: selectedIndex < scrollSnaps.length - 1
          })
        }) : null]
      }), _jsx(Carousel, {
        className: "-mx-6 w-[calc(100%+3rem)] @md:mx-0 @md:w-auto [&>div]:-m-1 [&>div]:overflow-visible [&>div]:p-1 @md:[&>div]:overflow-hidden",
        opts: {
          loop: shouldLoop,
          align: "start",
          slidesToScroll
        },
        setApi,
        children: _jsx(CarouselContent, {
          className: "ml-0 @md:-ml-6",
          children: carouselSlides.map(_temp)
        })
      })]
    });
    $[10] = api;
    $[11] = children;
    $[12] = hasMultiplePages;
    $[13] = loop;
    $[14] = scrollSnaps.length;
    $[15] = selectedIndex;
    $[16] = slideIds;
    $[17] = slides;
    $[18] = slidesToScroll;
    $[19] = subTitle;
    $[20] = title;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(slide, index_1) {
  return _jsx(CarouselItem, {
    className: ["basis-[80%] pl-3 @sm:basis-1/2 @md:basis-1/3 @md:pl-6 @lg:basis-1/4", index_1 === 0 ? "pl-6" : "pl-3"].join(" "),
    children: slide.node
  }, slide.id);
}